import { graphql } from 'gatsby';
import React from 'react';

interface VideoStreamBlock {
  block: {
    html: string;
    max_width: string;
  };
}

const VideoStream: React.FC<VideoStreamBlock> = ({ block }) => {
  return (
    <div className='block__video-stream'>
      <div className={`video-block ${block.max_width}`}>
        <div
          className='video-block__wrapper'
          dangerouslySetInnerHTML={{ __html: block.html }}
        />
      </div>
    </div>
  );
};

export default VideoStream;

export const videoStreamFragment = graphql`
  fragment VideoStreamBlockFragment on Block {
    html
    max_width
  }
`;
